module.exports = __webpack_public_path__ + "static/media/healthy_fish.392dd18e.png";